import ReactPixel from "react-facebook-pixel";

export const initMetaPixel = () => {
  const pixelId = process.env.REACT_APP_META_PIXEL_ID;
  if (!pixelId) return;

  ReactPixel.init(pixelId, {}, { autoConfig: true, debug: false });
  ReactPixel.pageView();
};

export const pageView = (path) => {
  if (path) {
    ReactPixel.pageView({ path });
  } else {
    ReactPixel.pageView();
  }
};

export const track = (event, data = {}) => {
  ReactPixel.track(event, data);
};

export const trackCustom = (event, data = {}) => {
  ReactPixel.trackCustom(event, data);
};

// Track 'Add to Basket' event
export const trackAddToBasket = (data = {}) => {
  ReactPixel.track("AddToCart", data);
};
